import apiClient from '@/services/axios'

export const get = async () => {
    const response = await apiClient.get('/mediaspace')
    return response.data
} 